import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

/**
 * Start a Stripe checkout for a lookup_key and redirect to it.
 * Returns true on redirect, false on failure.
 */
export async function startSubscription(lookup_key, metadata = {}) {
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key,
      origin_url: window.location.origin,
      metadata,
    });
    window.location.href = data.checkout_url;
    return true;
  } catch (e) {
    toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed to start checkout");
    return false;
  }
}

/**
 * Given an axios error, if it's a 402 with an upgrade_needed payload,
 * return the detail so the caller can render <PaywallModal detail={...} />.
 * Returns detail object if 402/upgrade, else null.
 */
export function extractPaywallDetail(err) {
  const detail = err?.response?.data?.detail;
  if (err?.response?.status === 402 && detail && detail.upgrade_needed) {
    return detail;
  }
  return null;
}
